import apiHeader from '@/helpers/apiHeader';

const manageAccountService = {
    list(params) {
        return apiHeader.get('manage-account/account-list', { params });
    },
    updateStatus(id, payload) {
        return apiHeader.patch(`manage-account/account-list/${id}/status`, payload);
    },
    create(formData) {
        return apiHeader.post('manage-account/account-list', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    update(id, data) {
        return apiHeader.put(`manage-account/account-list/${id}`, data);
    },
    updateWithFile(id, formData) {
        return apiHeader.post(`manage-account/account-list/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
    },
    delete(id) {
        return apiHeader.delete(`manage-account/account-list/${id}`);
    },
    get(id) {
        return apiHeader.get(`manage-account/account-list/${id}`);
    },
    getSectionsByUsername(username) {
        return apiHeader.get(`manage-account/account-list/${username}/sections`);
    },
    getSubSectionsByUsername(username) {
        return apiHeader.get(`manage-account/account-list/${username}/sub-sections`);
    },
    // ... method lain jika diperlukan
};

export default manageAccountService;